import React, { Component } from "react";
import FlatButton from "material-ui/FlatButton";
import ActionDownload from "material-ui/svg-icons/file/cloud-download";
import Snackbar from "material-ui/Snackbar";
import { RestApiDownloadKOL, API_REPORT } from "../restClient";
import { pink400 } from "material-ui/styles/colors";

class DownloadKol extends Component {
  constructor(props) {
    super(props);
    this.state = {
      autoHideDuration: 4000,
      message: "Please try again",
      open: false
    };
  }
  handleRequestClose = () => {
    this.setState({
      open: false
    });
  };

  loadReport = () => {
    const agencyId = this.props.match.params.id;
    if (agencyId) {
      RestApiDownloadKOL(agencyId)
        .then(response => {
          if (response.status >= 400) {
            throw new Error("Bad response from server");
          }
          return response.json();
        })
        .then(data => {
          if (data && data.url) {
            this.downloadfile(data.url);
          } else {
            this.setState({ open: true });
          }
        })
        .catch(e => {
          this.setState({ open: true });
          // console.error(e);
        });
    } else {
      this.setState({ open: true });
    }
  };
  downloadfile = url => {
    let tempLink = document.createElement("a");
    tempLink.style.display = "none";
    // "http://api.staging.ola.id"
    tempLink.href = API_REPORT + url;
    let resfile = url.lastIndexOf("/") + 1;
    let newfileName = url.substring(resfile, url.length);
    tempLink.setAttribute("download", newfileName);
    // Safari thinks _blank anchor are pop ups. We only want to set _blank
    // target if the browser does not support the HTML5 download attribute.
    // This allows you to download files in desktop safari if pop up blocking
    // is enabled.
    if (typeof tempLink.download === "undefined") {
      tempLink.setAttribute("target", "_blank");
    }
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  };
  render() {
    const { open, message, autoHideDuration } = this.state;
    return (
      <div>
        <FlatButton
          icon={<ActionDownload />}
          label="Download"
          onClick={this.loadReport.bind(this)}
          primary={true}
        />
        <Snackbar
          open={open}
          bodyStyle={{ backgroundColor: pink400 }}
          message={message}
          autoHideDuration={autoHideDuration}
          onRequestClose={this.handleRequestClose}
        />
      </div>
    );
  }
}

export default DownloadKol;



// WEBPACK FOOTER //
// ./src/agency/DownloadKol.js